<template>
    <main-layout>
        <div class="-pt-nav">
            <div class="background__icons-sm">
                <div class="container -pt-4 -pt-sm-8 -pb-xs1-4 -pb-sm-12 text-center">
                    <h1 class="heading-48 form__title">404</h1>
                    <p class="text-20 -pt-2">Nie znaleziono strony.</p>
                    <div class="d-flex justify-content-center -pt-4">
                        <router-link :to="{ name: 'home' }" class="button__blue">Wróć do strony głównej</router-link>
                    </div>
                </div>
            </div>
        </div>
    </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";

export default {
    components: {
        MainLayout,
    },
};
</script>
